//
// Copyright 2025 DXOS.org
//

import * as Schema from 'effect/Schema';

import * as Operation from '@dxos/compute/Operation';
import { DXN } from '@dxos/keys';
import { trim } from '@dxos/util';

export const Fetch = Operation.make({
  meta: {
    key: DXN.make('org.dxos.function.web-search.fetch'),
    name: 'Fetch web page',
    icon: 'ph--globe-simple--regular',
    description: trim`
      Fetches the content of a web page and returns the HTML. 
      Use this to get the content of a web page.
    `,
  },
  input: Schema.Struct({
    url: Schema.String.annotations({
      description: 'The URL of the web page to fetch.',
    }),
  }),
  output: Schema.String,
});
